module.exports = __webpack_public_path__ + "img/anti-corrosion-2.7c71ee26.webp";